import Skeleton from '@/components/common/Skeleton';
import styled from 'styled-components';

const ImageSkeleton = ({ mobile }: { mobile: boolean }) => (
  <Skeleton width={mobile ? '40px' : '67px'} height={mobile ? '40px' : '67px'} />
);
const TitleSkeleton = ({ mobile }: { mobile: boolean }) => (
  <Skeleton width={mobile ? '40px' : '50px'} height={mobile ? '10px' : '12px'} />
);

const CategoryListSkeleton = ({
  count = 4,
  mobile = false,
}: {
  count?: number;
  mobile?: boolean;
}) => {
  return Array.from({ length: count }, (_, index) => (
    <SkeletonContainer key={index} $mobile={mobile}>
      <ImageSkeleton mobile={mobile} />
      <TitleSkeleton mobile={mobile} />
    </SkeletonContainer>
  ));
};

export default CategoryListSkeleton;

const SkeletonContainer = styled.div<{ $mobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $mobile }) => ($mobile ? 'center' : 'stretch')};
  gap: 5px;
`;
